import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import FancyButton from "../ui/fancy-button";
import BasicBlock from "./basic-block";

export const FAQ_DATA = [
  {
    question: "Can I cancel my plan?",
    answer:
      "Yes. You can cancel your plan anytime via settings. Your plan will remain active until the end of the billing cycle.",
  },
  {
    question: "What is a workflow credit?",
    answer:
      "A workflow credit is a video auto-edited by Crayo's AI. This includes Fake Texts, Reddit, ChatGPT, Split-screen, Streamer Videos, etc.",
  },
  {
    question: "How long is a VEO3 video?",
    answer: "VEO3 videos are 8 seconds long. This is a model-limit, not a crayo limit.",
  },
  {
    question: "Is VEO3 free?",
    answer:
      "No. VEO3 has a special credit type you must purchase seperately due to high cost of generation",
  },
  {
    question: "How do I view my usage?",
    answer:
      "You can view your usage in settings. Click your profile picture in the top right corner.",
  },
  {
    question: "Do you have a refund policy?",
    answer:
      "Unfortunately, we do not offer refunds. You can cancel your plan anytime and your plan will remain active until the end of the billing cycle.",
  },
  {
    question: "What is an export minute?",
    answer:
      "An export minute is the length of video you can generate with Crayo. For example, if you have 60 export minutes, you can generate a 1 minute video 60 times.",
  },
  {
    question: "Can I monetize videos created with Crayo?",
    answer:
      "Yes. You fully own the rights to all videos. We use custom recorded gameplay to ensure originality.",
  },
  {
    question: "Can I generate in other languages?",
    answer:
      "Yes. We support most languages. Simply provide the text in the language you want to generate in. Contact support if you need a language that is not supported.",
  },
  {
    question: "Can I import images from ChatGPT to Crayo?",
    answer: "Yes. You can import images to both our editor, and AI workflows.",
  },
] as const;

const FAQHeader = (
  <h3 className="text-center text-[35px] font-semibold md:text-[45px]">
    <p className="text-[30px] font-medium text-[#335CFF]">FAQs</p>
    <span className="hidden select-none sm:block">Frequently asked questions</span>
    <span className="block select-none md:hidden">Frequent questions</span>
  </h3>
);

const FAQ = () => (
  <BasicBlock
    header={FAQHeader}
    contentStyle="flex-col md:gap-16 gap-6 items-center justify-center"
  >
    <Accordion
      type="single"
      collapsible
      className="grid w-full grid-cols-1 gap-[22px] md:grid-cols-2"
    >
      {FAQ_DATA.map((item, index: number) => (
        <AccordionItem
          key={index}
          value={`item-${index}`}
          className={
            "max-h-fit rounded-2xl border border-[#EFF2FF] bg-white p-[30px] py-2 shadow-sm"
          }
        >
          <AccordionTrigger className="text-left text-[12px] font-semibold tracking-wide text-[#101828] md:text-base">
            {item.question}
            <FaCirclePlus className="mb-1 mr-2 size-5 shrink-0 text-[#525866] transition-transform duration-200 group-data-[state=open]:hidden" />
            <FaCircleMinus className="mb-1 mr-2 size-5 shrink-0 text-[#525866] transition-transform duration-200 group-data-[state=closed]:hidden" />
          </AccordionTrigger>
          <AccordionContent className="text-sm font-light leading-normal text-[#525866]">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
    <div className="flex w-full flex-col items-start justify-between gap-5 rounded-2xl border border-[#CACFD8] bg-[#F9FBFF] px-4 py-6 sm:px-[40px] sm:py-[30px] md:flex-row md:items-center md:gap-0">
      <div className="flex flex-col gap-1">
        <h3 className="text-xl font-medium text-[#101828]">Still have questions?</h3>
        <p className="text-sm tracking-wide text-[#525866]">
          Contact our 24/7 support team for any concerns or inquiries.
        </p>
      </div>
      <FancyButton className="whitespace-nowrap" href="/discord" size="lg" inNewTab>
        Get in touch
      </FancyButton>
    </div>
  </BasicBlock>
);

export default FAQ;
